var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"h4"},_vm._l((_vm.locales),function(locale){return _c('b-badge',{key:locale.id,staticClass:"mr-1",attrs:{"variant":"light"}},[_vm._v(" "+_vm._s(_vm.getLanguageTitle(locale.languageId))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }